import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';

type ConfirmButtonSeverity = 'success' | 'info' | 'warning' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast';

export interface DialogConfirmData {
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmSeverity?: ConfirmButtonSeverity;
  hideCancel?: boolean;
}

@Component({
  selector: 'dialog-confirm',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './dialog-confirm.component.html'
})
export class DialogConfirmComponent implements AfterViewInit {

  @ViewChild('btnNo') btnNo!: ElementRef;
  public readonly message: string;
  public readonly confirmLabel: string;
  public readonly cancelLabel: string;
  public readonly confirmSeverity: ConfirmButtonSeverity;
  public readonly hideCancel: boolean;

  constructor(
    private readonly _ref: DynamicDialogRef,
    private readonly _config: DynamicDialogConfig<DialogConfirmData>
  ) {
    this.message = this._config.data?.message ?? 'Are you sure you want to continue?';
    this.confirmLabel = this._config.data?.confirmLabel ?? 'Yes';
    this.cancelLabel = this._config.data?.cancelLabel ?? 'No';
    this.confirmSeverity = this._config.data?.confirmSeverity ?? 'primary';
    this.hideCancel = this._config.data?.hideCancel ?? false;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.btnNo?.nativeElement.blur();
    }, 10);
  }

  onNoClicked() {
    this._ref.close(false);
  }

  onConfirmClicked() {
    this._ref.close(true);
  }
}